import React from 'react';
import { Link } from 'react-router-dom';
import cImg from '../../images/prices/image-1.jpg';

const Newsletter = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='relative pt-[100px] pb-[95px] z-10'>
			<div className='wraper'>
				<div className='grid grid-cols-12 gap-3'>
					<div className='col-span-12 md:col-span-12 col:col-span-12'>
						<div className='col:w-full mx-auto'>
							<h3 className='text-[36px] sm:text-[22px] font-medium mb-[40px] sm:mb-[30px] text-[#282e3f]'>
								Honoraires
							</h3>
							<p className='text-[#666] pb-8'>
								Une transparence totale est garantie dans le calcul des frais et honoraires.
							</p>
							<p className='text-[#666] pb-8'>
								Lors du premier rendez-vous, le cabinet examinera avec vous la façon de calculer ces
								frais et honoraires qui tiendra notamment compte de l'importance et de la nature de
								l'affaire, de son degré d'urgence, du temps qui y est consacré, du résultat obtenu et du
								service rendu. Un document explicatif détaillé vous sera remis, que le cabinet vous
								priera de signer pour accord de manière à éviter tout quiproquo éventuel.
							</p>
							<p className='text-[#666] pb-8'>
								Les honoraires seront fixés sur la base d'un taux horaire (généralement) ou d'un forfait
								selon le type d'affaires.
							</p>
							<p className='text-[#666] pb-8'>
								En effet, compte tenu du caractère imprévisible de l'évolution d'un dossier
								(conciliation, contestations, expertise, mesures d'instructions, appel, …), il n'est pas
								toujours aisé de travailler sur la base d'un forfait mais, pour certaines matières, ce
								mode de calcul peut être envisagé.
							</p>
							<p className='text-[#666] pb-8'>
								Les frais et honoraires sont soumis à la TVA, au taux de 21%.
							</p>
							<p className='text-[#666] pb-8'>
								Les frais de procédure (frais d'huissier, frais de greffe, etc…) et les autres débours
								seront ajoutés si vous ne les avez pas payés vous-même ; vous pourrez bien sûr en
								demander les pièces justificatives.
							</p>
							<p className='text-[#666] pb-8'>
								L'état de frais et honoraires est habituellement établi à l'issue du dossier mais le
								versement d'une provision est demandé à l'entame de ce dernier. Il arrive que des
								avances complémentaires doivent être versées, qui ne sont pas forcément représentatives
								de l'état d'avancement de l'affaire. Mais à tout moment vous pouvez solliciter
								l'établissement d'un état de frais et honoraires intermédiaire.
							</p>
							<p className='text-[#666] pb-8'>
								Enfin, en fonction du montant de vos revenus, vous pouvez bénéficier de l'aide juridique
								gratuite ou partiellement gratuite (intervention forfaitaire comprise entre 25 et 125 €
								par désignation) dans le cadre de l'aide juridique légale (anciennement Pro deo)
								cependant que le cabinet se réserve le droit de ne pas intervenir dans le cadre de
								l'aide juridique légale dans certains cas ou pour certaines matières.
							</p>
							<p className='text-[#666] pb-8'>
								Le cabinet reste à votre disposition pour tous renseignements complémentaires à ce sujet
								afin d'éviter tout malentendu.
							</p>
							<Link
								onClick={ClickHandler}
								to='/contact'
								className='bg-[#c0b596] cursor-pointer text-[16px] font-semibold text-white px-[38px] py-[10px]  capitalize inline-block mt-[6px] transition ease-in-out duration-300 hover:bg-[#d4c291]
                            col:mb-[5px] col:mt-[15px] col:text-[15px] col:px-[18px] col:py-[8px] 
                            '
							>
								Contactez-nous
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Newsletter;
